import React from 'react';
import { Link } from 'react-router-dom';

import { WaitlistLogo } from '@/features/waiting-list/components/WaitlistLayout';

import '../styles/legal.css';

/**
 * Full-page PDF viewer for a legal document, mirroring the marketing site's
 * `PrivacyPolicy` / `TermsOfUse` pages: brand lockup linking home, the
 * document title, and the PDF in an 80vh frame with a plain link for
 * browsers that cannot embed PDFs.
 */
export default function LegalDocumentPage({ title, pdf }) {
    return (
        <main className="legal-page">
            <div className="legal-page-inner">
                <header className="legal-page-header">
                    <Link className="legal-page-brand" to="/" aria-label="specific ai home">
                        <WaitlistLogo size="small" />
                    </Link>
                </header>
                <div className="legal-page-title-row">
                    <h1 className="legal-page-title">{title}</h1>
                    <a className="legal-page-open" href={pdf} target="_blank" rel="noopener noreferrer">
                        Open PDF
                    </a>
                </div>
                <div className="legal-page-frame">
                    <iframe className="legal-page-iframe" src={pdf} title={title} />
                </div>
            </div>
        </main>
    );
}
